import Vivus from "vivus";
// import WOW from "wowjs";
// require('jquery-mask-plugin');

(function($) {
    "use strict";

    window.deco = $.extend(
        {},
        {
            preloader: $(".preloader"),

            init: function() {
                deco.ajaxLoader();
                deco.mobileMenu();
                deco.initSelect();
                deco.floatHeader();
                deco.scrollTo();
                deco.initDropdown();
                deco.initScrollParallax();
                deco.adaptiveImage();
                deco.chickAnimation();
                deco.initMouseParallax();
                deco.initMouseRotate();
                deco.openHiddenBlock();
                deco.singleProdSlider();
                deco.flowerAnimation();
                deco.dottedAnimationOne();
                deco.dottedAnimationOneMob();
                deco.dottedAnimationTwo();
                deco.dottedAnimationTwoMob();
                deco.modalSearch();
                deco.goToBtn();
                deco.animateSvg();
                deco.formRequestSelect();
                // deco.phoneMask();

                $(window).on("load", function() {
                    deco.winHeight = $(window).height();
                    deco.winWidth = $(window).width();
                });
                $(window).scroll(function() {
                    deco.winScroll = $(window).scrollTop();
                });
                $(window).resize(function() {
                    deco.winScroll = $(window).scrollTop();
                    deco.winHeight = $(window).height();
                    deco.winWidth = $(window).width();
                    deco.initAllparalax();
                    deco.adaptiveImage();
                });
            },

            preloaderToggle: function(event) {
                switch (event) {
                    case "show":
                        deco.preloader.addClass("active");
                        break;
                    case "hide":
                        deco.preloader.removeClass("active");
                        break;
                }
            },
            ajaxLoader: function() {
                var ajaxBtn = $(".js_ajax-load");

                ajaxBtn.click(function(e) {
                    e.preventDefault();
                    var url = $(this).data("url");
                    var containerId = $(this).data("container");
                    $.ajax({
                        url: url,
                        beforeSend: function() {
                            deco.preloaderToggle("show");
                        },
                        success: function(content) {
                            setTimeout(function() {
                                /* remove delay on prod */
                                deco.preloaderToggle("hide");
                                $("#" + containerId).html(content);
                            }, 1000);
                        }
                    });
                });
            },
            mobileMenu: function() {
                $(document).on("click", "#openMobileMenu", function(e) {
                    e.preventDefault();
                    $("#mobileMenu").toggleClass("opened");
                    $(this).toggleClass("is-active");
                    // $(".search_btn").removeClass("icon-cross-thin");
                    // $(".search_btn").addClass("icon-search");
                    $(".popup__overlay_search").removeClass("active");
                });

                $(document).on("click touchstart", function(e) {
                    if (
                        !$(e.target)
                            .parents()
                            .hasClass("mobile-menu") &&
                        !$(e.target).hasClass("mobile-menu") &&
                        !$(e.target)
                            .parents()
                            .hasClass("hamburger") &&
                        !$(e.target).hasClass("hamburger")
                    ) {
                        $("#mobileMenu").removeClass("opened");
                        $("#openMobileMenu").removeClass("is-active");
                    }
                });

                $(document).on(
                    "click",
                    ".mobile-menu  .menu-item-has-child > a",
                    function(e) {
                        e.preventDefault();
                        $(this).toggleClass("opened");
                        $(this)
                            .parents(".menu-item-has-child")
                            .find(".sub-menu")
                            .slideToggle();
                    }
                );

                $(document).on(
                    "click",
                    ".mobile-menu  .menu-shops-mob > a",
                    function(e) {
                        $("#mobileMenu").toggleClass("opened");
                        $("#openMobileMenu").toggleClass("is-active");
                        $(".popup__overlay_search").removeClass("active");
                    }
                );
            },
            initSelect: function() {
                jQuery(document).on(
                    "click",
                    ".custom-select .current-value",
                    function() {
                        if ($(this).hasClass("active")) {
                            jQuery(document)
                                .find(".custom-select")
                                .find(".current-value")
                                .removeClass("active");
                            jQuery(this).removeClass("active");
                        } else {
                            jQuery(document)
                                .find(".custom-select")
                                .find(".current-value")
                                .removeClass("active");
                            jQuery(this).addClass("active");
                        }
                    }
                );

                jQuery(document).on(
                    "click",
                    ".custom-select .list-values a",
                    function() {
                        var parent = jQuery(this).parents(".custom-select"),
                            value = jQuery(this).attr("data-val"),
                            th = jQuery(this),
                            trigger = parent.find(".current-value");

                        if (!$(this).hasClass("current")) {
                            trigger.removeClass("active").html($(this).html());
                            parent.find('input[type="hidden"]').val(value);
                            trigger.attr("data-val", value);
                            setTimeout(function() {
                                parent.find("a").removeClass("current");
                                th.addClass("current");
                            }, 400);
                        }
                        return false;
                    }
                );

                jQuery(document).on("click", function(e) {
                    if (
                        !jQuery(e.target)
                            .parents()
                            .hasClass("custom-select") &&
                        !jQuery(e.target).hasClass("custom-select")
                    ) {
                        jQuery(".custom-select .current-value").removeClass("active");
                    }
                });

                function fix_zIndex() {
                    if (jQuery(".custom-select").length) {
                        var count = 90;
                        jQuery(".custom-select").each(function() {
                            jQuery(this).css("z-index", count);
                            count--;
                        });
                    }
                }

                fix_zIndex();
            },
            floatHeader: function() {
                if ($(".header-wrap").length) {
                    var offsettopstickystatic = $(".header-wrap").offset().top;

                    $(window).on("resize", function() {
                        offsettopstickystatic = $(".header-wrap").offset().top;
                    });

                    $(window).on("scroll load", function() {
                        if ($(window).scrollTop() > offsettopstickystatic) {
                            $(".mainheader").addClass("fixed-head");
                        } else {
                            $(".mainheader").removeClass("fixed-head");
                            $(".mainheader").css("top", "0");
                        }
                    });
                }
            },
            scrollTo: function() {
                $(document).on("click", ".scroll_to", function(e) {
                    var elementClick = $(this).attr("data-href");
                    if ($('[data-id="' + elementClick + '"]').length) {
                        e.preventDefault();
                        var destination = $('[data-id="' + elementClick + '"]').offset()
                            .top;
                        if ($(".mainheader").length) {
                            destination =
                                $('[data-id="' + elementClick + '"]').offset().top -
                                $(".mainheader").outerHeight();
                        }

                        $("body,html").animate({ scrollTop: destination }, 800);
                    }
                });
            },
            initDropdown: function() {
                $(document).on("click", ".toggle_menu", function(e) {
                    $(this)
                        .parents(".toggle_dropdown_wrap")
                        .toggleClass("opened");
                });
            },
            transformStyle: function(item, val) {
                item.css({
                    "-webkit-transform": "translateY(" + val + "px) translate3d(0,0,0)",
                    "-moz-transform": "translateY(" + val + "px) translate3d(0,0,0)",
                    "-ms-transform": "translateY(" + val + "px) translate3d(0,0,0)",
                    "-o-transform": "translateY(" + val + "px) translate3d(0,0,0)",
                    transform: "translateY(" + val + "px) translate3d(0,0,0)"
                });
            },

            transformStyleXY: function(item, val) {
                item.css({
                    "-webkit-transform":
                        "translate(" + val.x + "px, " + val.y + "px) translate3d(0,0,0)",
                    "-moz-transform":
                        "translate(" + val.x + "px, " + val.y + "px) translate3d(0,0,0)",
                    "-ms-transform":
                        "translate(" + val.x + "px, " + val.y + "px) translate3d(0,0,0)",
                    "-o-transform":
                        "translate(" + val.x + "px, " + val.y + "px) translate3d(0,0,0)",
                    transform:
                        "translate(" + val.x + "px, " + val.y + "px) translate3d(0,0,0)"
                });
            },
            transformStyleRotate: function(item, val, transformOrigin) {
                item.css({
                    "-webkit-transform": "rotate(" + val + "deg)",
                    "-moz-transform": "rotate(" + val + "deg)",
                    "-ms-transform": "rotate(" + val + "deg)",
                    "-o-transform": "rotate(" + val + "deg)",
                    transform: "rotate(" + val + "deg)",
                    "transform-origin": transformOrigin
                });
            },
            mainBanParallax: function(parObj) {
                if (deco.winScroll <= deco.winHeight / 2) {
                    var transformVal = -deco.winScroll * (1 - parObj.speed);
                    deco.transformStyle(parObj.item, transformVal);
                }
            },

            partParallax: function(parObj) {
                // if ((deco.winScroll - parObj.winHeight - parObj.offsetTop < 0) && (deco.winScroll < parObj.height + parObj.offsetTop + deco.winHeight*3)) {
                var transformVal = -Math.round(deco.winScroll * (1 - parObj.speed));
                deco.transformStyle(parObj.item, transformVal);

                // }
            },

            initScrollParallax: function() {
                var paralaxItem = $(".parallax-item:not(.no-scrollParallax)");

                if (!paralaxItem.length) {
                    return false;
                }

                paralaxItem.each(function() {
                    var parItem = $(this);
                    var scrollFunction;

                    var parObj = {
                        item: parItem,
                        offsetTop: parItem.offset().top,
                        height: parItem.outerHeight(),
                        speed: parItem.data("par-speed")
                    };

                    if (parItem.hasClass("paralax-item--mainBann")) {
                        scrollFunction = function() {
                            deco.mainBanParallax(parObj);
                        };
                    } else if (parItem.hasClass("part")) {
                        scrollFunction = function() {
                            deco.partParallax(parObj);
                        };
                    } else if (parItem.hasClass("par-content")) {
                        scrollFunction = function() {
                            deco.partParallax(parObj);
                        };
                    } else {
                        return false;
                    }

                    $(window).on("load scroll resize", function() {
                        scrollFunction();
                    });
                });
            },
            initMouseParallax: function() {
                var parts = $(".parallax-item.part");
                var mouse = { x: 0, y: 0 };
                var transformVal = { x: 0, y: 0 };

                $(window).on("mousemove", function(e) {
                    mouse = {
                        x: Math.round(e.clientX),
                        y: Math.round(e.clientY)
                    };

                    parts.each(function() {
                        var partBg = $(this).find(".part__bg");
                        var speed = $(this).attr("data-par-speed");

                        transformVal = {
                            x: -Math.round(
                                ((mouse.x - deco.winWidth / 2) * (1 - speed)) / 10
                            ),
                            y: -Math.round(
                                ((mouse.y - deco.winHeight / 2) * (1 - speed)) / 10
                            )
                        };

                        deco.transformStyleXY(partBg, transformVal);
                    });
                });
            },
            initMouseRotate: function() {
                var parts = $(".transform_rotate");
                var mouse = { x: 0, y: 0 };
                var transformVal = { x: 0, y: 0 };

                $(window).on("mousemove", function(e) {
                    mouse = {
                        x: Math.round(e.clientX),
                        y: Math.round(e.clientY)
                    };

                    parts.each(function() {
                        var speed = $(this).attr("data-speed");
                        var transformOrigin = $(this).attr("data-transformOrigin");
                        transformVal = Math.round(
                            ((mouse.y - deco.winHeight / 2) * (1 - speed)) / 10
                        );

                        deco.transformStyleRotate($(this), transformVal, transformOrigin);
                    });
                });
            },
            initAllparalax: function() {
                if (!$("body").hasClass("mobile") && deco.winWidth > 960) {
                    deco.initScrollParallax();
                    deco.initMouseParallax();
                }
            },
            adaptiveImage: function() {
                if ($(".img_adaptive").length) {
                    if ($(window).width() < 600) {
                        $(".img_adaptive").each(function() {
                            var src = $(this).attr("data-tablet");
                            $(this).attr("src", src);
                        });
                    } else {
                        $(".img_adaptive").each(function() {
                            var src = $(this).attr("data-desktop");
                            $(this).attr("src", src);
                        });
                    }
                }
            },
            chickAnimation: function() {
                if ($(".animate_image").length) {
                    var viewport = $(".animation_viewport"),
                        img = $(".animate_image"),
                        srcDefault = img.attr("data-imgdefault"),
                        srcStart = img.attr("data-imgstart"),
                        srcLeft = img.attr("data-imgleft"),
                        srcRight = img.attr("data-imgright"),
                        startAnimation = false;

                    viewport
                        .on("mousemove", function(event) {
                            var x = event.clientX;
                            var width = viewport.outerWidth();

                            if (startAnimation == false) {
                                img.attr("src", srcStart);
                                setTimeout(function() {
                                    startAnimation = true;
                                }, 500);
                            } else {
                                if (x > width / 2) {
                                    img.attr("src", srcLeft);
                                } else if (x < width / 2) {
                                    img.attr("src", srcRight);
                                } else {
                                    img.attr("src", srcStart);
                                }
                            }
                        })
                        .on("mouseleave", function() {
                            img.attr("src", srcDefault);
                            startAnimation = false;
                        });
                }
            },
            openHiddenBlock: function() {
                $(document).on("click", ".open_hiddenblock", function(e) {
                    e.preventDefault();
                    var id = $(this).attr("data-block");
                    $(this).toggleClass("opened");
                    $(this)
                        .closest(".details-table")
                        .toggleClass("opened");
                    $('.hiddenblock[data-block="' + id + '"]').slideToggle();
                });
            },
            singleProdSlider: function() {
                if ($(".singleproduct_slider_main").length) {
                    $(".singleproduct_slider_main").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: false,
                        asNavFor: ".singleproduct_slider_nav"
                    });
                    $(".singleproduct_slider_nav").slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        asNavFor: ".singleproduct_slider_main",
                        dots: false,
                        arrows: false,
                        centerMode: false,
                        infinite: false,
                        variableWidth: true,
                        focusOnSelect: true
                    });
                }
            },
            flowerAnimation: function() {
                if ($("#flowerSvg").length) {
                    var top = $("#flowerSvg").offset().top;
                    var myVivus = new Vivus("flowerSvg", {
                        duration: 100,
                        start: "manual",
                        type: "sync",
                        animTimingFunction: Vivus.EASE,
                        onReady: function(myVivus) {
                            // `el` property is the SVG element
                            // myVivus.el.setAttribute('height', 'auto');
                        }
                    });
                    $(window).on("scroll", function() {
                        if ($(window).scrollTop() > top - $(window).outerHeight()) {
                            myVivus.play(function() {
                                $(".hidden_part").css("opacity", 1);
                            });
                        }
                    });
                }
            },
            dottedAnimationOne: function() {
                if ($("#dottedLineOne").length) {
                    let myVivus = new Vivus("dottedLineOne", {
                        duration: 100,
                        start: "manual",
                        type: "oneByOne",
                        animTimingFunction: Vivus.EASE,
                        onReady: function(myVivus) {
                            // `el` property is the SVG element
                            // myVivus.el.setAttribute('height', 'auto');
                        },
                        function() {

                        }
                    });
                    $(window).on("scroll", function() {
                        let wt = $(window).scrollTop(),
                            wh = $(window).outerHeight(),
                            et = $("#step-item_2").offset().top,
                            eh = $("#step-item_2").outerHeight();
                        if ( wt + wh >= et + eh ) {
                            myVivus.play();
                        }
                    });
                }
            },
            dottedAnimationOneMob: function() {
                if ($("#dottedLineOneMob").length) {
                    let myVivus = new Vivus("dottedLineOneMob", {
                        duration: 100,
                        start: "manual",
                        type: "oneByOne",
                        animTimingFunction: Vivus.EASE,
                        onReady: function(myVivus) {
                            // `el` property is the SVG element
                            // myVivus.el.setAttribute('height', 'auto');
                        },
                        function() {

                        }
                    });
                    $(window).on("scroll", function() {
                        let wt = $(window).scrollTop(),
                            wh = $(window).outerHeight(),
                            et = $("#step-item_1").offset().top,
                            eh = $("#step-item_1").outerHeight();
                        if ( wt + wh >= et + eh ) {
                            myVivus.play();
                        }
                    });
                }
            },
            dottedAnimationTwo: function() {
                if ($("#dottedLineTwo").length) {
                    let myVivus = new Vivus("dottedLineTwo", {
                        duration: 100,
                        start: "manual",
                        type: "oneByOne",
                        animTimingFunction: Vivus.EASE,
                        onReady: function(myVivus) {
                            // `el` property is the SVG element
                            // myVivus.el.setAttribute('height', 'auto');
                        },
                        function() {

                        }
                    });
                    $(window).on("scroll", function() {
                        let wt = $(window).scrollTop(),
                            wh = $(window).outerHeight(),
                            et = $("#step-item_3").offset().top,
                            eh = $("#step-item_3").outerHeight();
                        if ( wt + wh >= et + eh ) {
                            myVivus.play();
                        }
                    });
                }
            },
            dottedAnimationTwoMob: function() {
                if ($("#dottedLineTwoMob").length) {
                    let myVivus = new Vivus("dottedLineTwoMob", {
                        duration: 100,
                        start: "manual",
                        type: "oneByOne",
                        animTimingFunction: Vivus.EASE,
                        onReady: function(myVivus) {
                            // `el` property is the SVG element
                            // myVivus.el.setAttribute('height', 'auto');
                        },
                        function() {

                        }
                    });
                    $(window).on("scroll", function() {
                        let wt = $(window).scrollTop(),
                            wh = $(window).outerHeight(),
                            et = $("#step-item_2").offset().top,
                            eh = $("#step-item_2").outerHeight();
                        if ( wt + wh >= et + eh ) {
                            myVivus.play();
                        }
                    });
                }
            },
            modalSearch: function() {
                //esc
                $(document).keyup(function(event) {
                    if (event.which == "27") {
                        $(".popup__overlay").removeClass("active");
                        $(".hamburger").removeClass("is-active");
                        $("body, html").removeClass("no-scroll");
                    }
                });
                //header input
                $(".search-input")
                    .focus(function() {
                        $(".search_form").addClass("focus");
                    })
                    .blur(function() {
                        $(".search_form").removeClass("focus");
                    });
                //main code
                $(".search_btn").on("click", function(e) {
                    e.preventDefault();
                    // if ($(window).width() < 600) {
                    //     $(this).toggleClass("icon-search");
                    //     $(this).toggleClass("icon-cross-thin");
                    // }
                    $(".popup__overlay_search").toggleClass("active");
                    setTimeout(function() {
                        $(".search_input_modal").focus();
                    }, 410);
                    $(".mobile-menu").removeClass("opened");
                    /* copy val */
                    // !!! DISABLED !!!
                    // var searchValueDesktop = $(".search_input_desktop").val();
                    // var searchValueMobile = $(".search_input_mobile").val();
                    // $(".search_input_modal").val(searchValueDesktop + searchValueMobile);
                });
                // close
                $(".popup__close").on("click", function() {
                    $(".popup__overlay_search").removeClass("active");
                    $("body, html").removeClass("no-scroll");
                    $(".hamburger").removeClass("is-active");
                });
            },
            goToBtn: function() {
                $(".btn-scroll").on("click", function(e) {
                    e.preventDefault();
                    var target = $("#gotoscreen").offset().top;

                    $("body,html")
                        .stop()
                        .animate({ scrollTop: target }, 800);
                    return false;
                });
            },
            animateSvg: function() {
                $(window).scroll(function() {
                    var scrolled = $(window).scrollTop();

                    $(".item-animate").each(function() {
                        var offset_wrapper =
                            $(this)
                                .closest(".wrapper-animate")
                                .offset().top -
                            $(this)
                                .closest(".wrapper-animate")
                                .height();
                        var delay = $(this).attr("data-delay");
                        var element = $(this);

                        if (scrolled > offset_wrapper) {
                            setTimeout(function() {
                                element.addClass("animate");
                            }, delay);
                        }
                    });
                });
            },
            formRequestSelect: function() {
                function DropDown(el) {
                    this.dd = el;
                    this.initEvents();
                }

                DropDown.prototype = {
                    initEvents: function() {
                        var obj = this;

                        obj.dd.on("click", function(event) {
                            $(this).toggleClass("active");
                            event.stopPropagation();
                        });
                        $("#dd ul li div").on("click", function() {});
                    }
                };
                $(function() {
                    var dd = new DropDown($("#dd"));
                    $(document).click(function() {
                        // all dropdowns
                        $(".wrapper-dropdown-5").removeClass("active");
                    });
                });
            },
            // phoneMask: function () {
            //     $(document).ready(function($) {
            //         if($('.your-phone input')){
            //             $('.your-phone input').mask('+38 (000) 000-00-00');
            //         }
            //     });
            // }
        }
    );

    deco.init();
})(jQuery);
